var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSendMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 53") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messages---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 36.5,
    cy: 36.5,
    r: 36.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "sent",
    transform: "translate(20.000000, 18.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0050643,16.3905545 L2.60461717,0.191141631 C1.95597534,-0.1357996 1.17022237,-0.0373656678 0.620019398,0.440742004 C0.0698164247,0.918849677 -0.137608178,1.67995479 0.0926684601,2.37075014 L4.70292503,16.2007176 L17.9997516,16.2007176 C18.9946872,16.2007176 19.7997764,17.0057665 19.7997764,18.0006523 C19.7997764,18.9955382 18.9946872,19.8005871 17.9997516,19.8005871 L4.70292503,19.8005871 L0.0926684601,33.6305547 C-0.137608178,34.3213501 0.0698166048,35.0824552 0.620019578,35.5605628 C0.954008428,35.8505914 1.37588925,36 1.79952798,36 C2.0737506,36 2.34973095,35.936721 2.60461717,35.810163 L35.0050643,19.6107501 C35.6150337,19.304902 36,18.682659 36,18.0006523 C36,17.3186457 35.6150337,16.6964027 35.0050643,16.3905545 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendMessage);
export default __webpack_public_path__ + "static/media/ic_send_message.2ad89eeecce7143f479b04dd597b6420.svg";
export { ForwardRef as ReactComponent };